import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a2b9063a")

_pushScopeId("data-v-a2b9063a")
const _hoisted_1 = { class: "p-4 md:pt-8 bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative w-full" }
const _hoisted_2 = { class: "flex flex-col px-4 gap-y-2 w-full md:w-auto md:gap-y-0 md:px-0 md:flex-row md:gap-x-2 on-process-stt" }
const _hoisted_3 = { class: "font-semibold text-20px whitespace-no-wrap text-black-lp-200 capitalize" }
const _hoisted_4 = {
  key: 2,
  class: "my-2 custom-table-style"
}
const _hoisted_5 = { class: "hidden" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Search = _resolveComponent("Search")!
  const _component_advanced_filter = _resolveComponent("advanced-filter")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Header = _resolveComponent("Header")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_Book = _resolveComponent("Book")!
  const _component_DetailRejectPopup = _resolveComponent("DetailRejectPopup")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _withDirectives(_createVNode("div", {
        class: "fixed right-0 h-full z-20 advanced-filter-custom-style",
        style: 
        `background-color:rgba(0,0,0,0.3); top: 8.5rem; width: calc(100% - ${
          _ctx.isAdvancedFilterOpened && _ctx.isCollapseSidebar ? `70px` : `264px`
        });`
      
      }, null, 4), [
        [_vShow, _ctx.isAdvancedFilterOpened]
      ]),
      _createVNode(_component_Breadcrumb),
      _createVNode(_component_Header, { class: "items-center" }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("onProcessStt.pageTitle")), 1),
            _createVNode(_component_Search, {
              onInput: _ctx.onSearch,
              onClear: _ctx.clearSearch,
              value: _ctx.searchValue,
              class: "w-250px",
              placeholder: _ctx.$t('onProcessStt.filter.searchPlaceholder')
            }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
            _createVNode(_component_advanced_filter, {
              "model-value": _ctx.advancedFilterData,
              isOriginDestination: true,
              isProduct: "",
              isCOD: "",
              isDFOD: "",
              addSumFilter: 
            _ctx.advancedFilterData.DFOD ? 1 : _ctx.isAccountForeignMyAndConsole ? -1 : 0
          ,
              isAsuransi: "",
              isDisabled: false,
              customDropdownWidth: "w-377px",
              onChange: _ctx.onChangeAdvancedFilter,
              onOpened: _ctx.onOpenedAdvancedFilter,
              onReset: _ctx.onResetAdvancedFilter,
              productDefaultSelected: _ctx.defaultProductSelected,
              isCustomDropdownChevronDisabled: true,
              isFilterOnlyInterpack: _ctx.isAccountForeign,
              titleProductCustom: _ctx.$t('Produk')
            }, null, 8, ["model-value", "addSumFilter", "onChange", "onOpened", "onReset", "productDefaultSelected", "isFilterOnlyInterpack", "titleProductCustom"]),
            _createVNode(_component_Select, {
              class: "w-40",
              onOpenSelect: _ctx.onOpenSelectStatus,
              onCloseSelect: _ctx.onCloseSelectStatus,
              isOpenMenu: _ctx.isOpenSelectStatus,
              value: _ctx.filterStatus,
              onChooseSelect: _ctx.onSelectStatus,
              dataSelect: _ctx.listStatus
            }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
          ])
        ]),
        _: 1
      }),
      (_ctx.isError && !_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_ErrorMessage, {
            key: 0,
            errorType: _ctx.errorCause,
            onTryAgain: _ctx.onRequest
          }, null, 8, ["errorType", "onTryAgain"]))
        : (_ctx.shipmentBooking.length === 0 && _ctx.firstRequest && !_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_EmptyState, {
              key: 1,
              data: "data On Process STT"
            }))
          : (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode(_component_TableV2, {
                columns: _ctx.columns,
                data: _ctx.shipmentBooking,
                loading: _ctx.isLoading,
                pagination: _ctx.pagination,
                "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
                onRequest: _ctx.onRequest,
                groupOptions: _ctx.actionGroupOptions,
                onClick: _ctx.goToDetail,
                isDetailAble: _ctx.isDetailAble,
                groupAction: true,
                isRightFreeze: true,
                totalColumnFreeze: 1,
                "delete-tooltip": "Batalkan Booking",
                onDeleteItem: _ctx.onOpenPopupCancelBooking,
                isPinnedScrollBottom: "",
                pinnedSubstractHeight: "220px",
                paginationStyle: "v3"
              }, null, 8, ["columns", "data", "loading", "pagination", "onRequest", "groupOptions", "onClick", "isDetailAble", "onDeleteItem"])
            ]))
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_Book, { ref: "book" }, null, 512)
    ]),
    (_ctx.isRejectPopup)
      ? (_openBlock(), _createBlock(_component_DetailRejectPopup, {
          key: 0,
          "is-detail": true,
          isShow: _ctx.isRejectPopup,
          "onUpdate:isShow": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isRejectPopup = $event)),
          sttNumber: _ctx.sttNumberSelected,
          onSuccess: _ctx.onRequest
        }, null, 8, ["isShow", "sttNumber", "onSuccess"]))
      : _createCommentVNode("", true)
  ], 64))
})